import createIcon from '../../createIcon';

/**
 * @component @name Vibration
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCAxNUgyVjlIMFYxNVpNMyAxN0g1VjdIM1YxN1pNMjIgOVYxNUgyNFY5SDIyWk0xOSAxN0gyMVY3SDE5VjE3Wk0xNi41IDNINy41QzYuNjcgMyA2IDMuNjcgNiA0LjVWMTkuNUM2IDIwLjMzIDYuNjcgMjEgNy41IDIxSDE2LjVDMTcuMzMgMjEgMTggMjAuMzMgMTggMTkuNVY0LjVDMTggMy42NyAxNy4zMyAzIDE2LjUgM1pNMTYgMTlIOFY1SDE2VjE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Vibration = createIcon('Vibration', [
  [
    'path',
    {
      d: 'M0 15H2V9H0V15ZM3 17H5V7H3V17ZM22 9V15H24V9H22ZM19 17H21V7H19V17ZM16.5 3H7.5C6.67 3 6 3.67 6 4.5V19.5C6 20.33 6.67 21 7.5 21H16.5C17.33 21 18 20.33 18 19.5V4.5C18 3.67 17.33 3 16.5 3ZM16 19H8V5H16V19Z',
      key: '1yfah0',
    },
  ],
]);

export default Vibration;
